import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

/**
 * Gets the selected country code from CMS configuration
 * Falls back to 'all' if not configured
 */
export const useSelectedCountryCode = (): string => {
    const content = useJurisdictionStore(store => store.jurisdictionSettings?.productConfig?.keyValuePairs);
    const cmsContent = content?.['Content Keys'];
    return cmsContent?.selectedCountryCode ?? 'all';
};
